/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_IMG,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOANUNCIOS} from "../../Constantes";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Proyectos from "../Dialogos/Dialogo_Proyectos";

const Seccion_Proyectos = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'proyectos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Proyectos,
        titulo: 'Detalles del anuncio',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    return (

        <Grid2 container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{marginTop: {xs: -18, sm: 0}}}>
                    <Tabla_Filtro
                        nombre={'Lista de proyectos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Seccion_Proyectos

const filtros = [
    {
        nombre: 'Titulo',
        direccion: 'asc',
        propiedad: 'titulo'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Imagen',
        direccion: 'left',
        propiedad: 'img',
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Titulo',
        direccion: 'left',
        propiedad: 'titulo',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Parrafo',
        direccion: 'left',
        propiedad: 'parrafo',
        lineas: 2,
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOANUNCIOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]